import mapApi from "@/api/monitorCenter/map.js";

const map = {
  state: {
    markerDatas: [],
    areaDatas: [],
    lineDatas: [],
    categoryList: []
  },
  mutations: {
    // FETCH_MARKER_DATAS(state, payload) {
    //   let aData = payload.data;
    //   if (Array.isArray(aData)) {
    //     state.markerDatas = aData;
    //   } else {
    //     state.markerDatas = [];
    //   }
    // },
    // FETCH_AREA_DATAS(state, payload) {
    //   let aData = payload.data;
    //   if (Array.isArray(aData)) {
    //     state.areaDatas = aData;
    //   } else {
    //     state.areaDatas = [];
    //   }
    // },
    // FETCH_LINE_DATAS(state, payload) {
    //   let aData = payload.data;
    //   if (Array.isArray(aData)) {
    //     state.lineDatas = aData;
    //   } else {
    //     state.lineDatas = [];
    //   }
    // },
    // FETCH_CATEGORY_DATAS(state, payload) {
    //   let aData = payload.data;
    //   if (Array.isArray(aData)) {
    //     state.categoryList = aData;
    //   } else {
    //     state.categoryList = [];
    //   }
    // }
  },
  actions: {
    // fetchMarkerDatasAct({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     mapApi
    //       .fetchMarkerDatas_Api()
    //       .then(res => {
    //         commit("FETCH_MARKER_DATAS", { data: res });
    //         resolve(state.markerDatas);
    //       })
    //       .catch(error => {
    //         reject(error);
    //       });
    //   });
    // },
    // fetchAreaDatasAct({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     mapApi
    //       .fetchAreaDatas_Api()
    //       .then(res => {
    //         commit("FETCH_AREA_DATAS", { data: res });
    //         resolve(state.areaDatas);
    //       })
    //       .catch(error => {
    //         reject(error);
    //       });
    //   });
    // },
    // fetchLineDatasAct({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     mapApi
    //       .fetchLineDatas_Api()
    //       .then(res => {
    //         commit("FETCH_LINE_DATAS", { data: res });
    //         resolve(state.lineDatas);
    //       })
    //       .catch(error => {
    //         reject(error);
    //       });
    //   });
    // },
    // fetchCategoryDatasAct({ commit, state }){
    //   return new Promise((resolve, reject) => {
    //     mapApi
    //       .fetchCategoryDatas_Api()
    //       .then(res => {
    //         commit("FETCH_CATEGORY_DATAS", { data: res.result });
    //         resolve(state.categoryList);
    //       })
    //       .catch(error => {
    //         reject(error);
    //       });
    //   });
    // }
  }
};

export default map;
